/**
 * Static configuration for the Ops Workspace tab.
 *
 * The tab is one surface with a left rail; each rail entry swaps the main
 * panel. Section keys double as the local view state and as the anchor the
 * PS-Kit summary band jumps to when an operator clicks a pending item.
 */

export const SECTIONS = {
    OVERVIEW: "overview",
    DOCUMENTS: "documents",
    ACCOUNT: "account",
    NACH: "nach",
    AGREEMENT: "agreement"
};

export const NAV_ITEMS = [
    {
        key: SECTIONS.OVERVIEW,
        label: "Case reference",
        sub: "Applicants · addresses · bank",
        icon:
            "M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z"
    },
    {
        key: SECTIONS.DOCUMENTS,
        label: "Documents",
        sub: "Review · tag · finalise",
        icon:
            "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M9 13h6M9 17h6"
    },
    {
        key: SECTIONS.ACCOUNT,
        label: "Account / Facility",
        sub: "Scheme · schedule",
        icon: "M3 4h18v16H3zM3 10h18M7 15h5"
    },
    {
        key: SECTIONS.NACH,
        label: "NACH mandate",
        sub: "Mandate · security",
        icon: "M2 5h20v14H2zM2 10h20"
    },
    {
        key: SECTIONS.AGREEMENT,
        label: "Agreement",
        sub: "PS Kit e-sign",
        icon: "M12 20h9M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"
    }
];

// Document-review filter chips. `company` / `pending` are computed filters;
// anything else is matched against the document's associate id.
export const DOC_FILTER_ALL = "all";
export const DOC_FILTER_COMPANY = "company";
export const DOC_FILTER_PENDING = "pending";

// DOCUMENT_CURRENT_STATUS values (constants/enums) mapped to the three visual
// states the workspace shows. Anything not Verified / Pending Approval is
// treated as "not on file yet".
export const DOC_STATUS = {
    VERIFIED: 2,
    PENDING: 3,
    REQUESTED: 1,
    REJECTED: 4,
    ARCHIVED: 5
};

// Archiving and restoring a file is only offered on the ops stage, the same
// gate the Document Review list applies.
export const DOCS_ARCHIVE_STAGE = 11;

// Documents the PS Kit gate treats as applicant-level KYC. Ids come from the
// backend document master (apps/cases/apis/v2/case_document_checklist.py).
export const APPLICANT_DOCUMENT_IDS = [7, 6, 63];

export const CHECKLIST_STATE = {
    COMPLETE: "complete",
    MISSING: "missing",
    WRONG: "wrong"
};
